import React from 'react';
import PropTypes from 'prop-types';
import {SVGIcon} from '@homeaway/react-svg';
import {LOCATION__16} from '../../components/svg-def';
import './listing-location.less';

function ListingLocation({baseLocation}) {
    const fullLocation = baseLocation && baseLocation.name && baseLocation.name.full;

    return (
        <div className="listing-location">
            {fullLocation &&
                <SVGIcon className="location-icon" markup={LOCATION__16} />
            }
            <span className="location-text">
                {fullLocation}
            </span>
        </div>
    );
}

ListingLocation.propTypes = {
    baseLocation: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

export default ListingLocation;


// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-location.js